export class Answer implements IAnswer {
  questionFieldName!: string | undefined;
  answerText!: string | undefined;
  screeningResultLabel!: string | undefined;

  constructor(data?: IAnswer) {
      if (data) {
          for (var property in data) {
              if (data.hasOwnProperty(property))
                  (<any>this)[property] = (<any>data)[property];
          }
      }
  }

  init(_data?: any) {
      if (_data) {
          this.questionFieldName = _data["questionFieldName"];
          this.answerText = _data["answerText"];
          this.screeningResultLabel = _data["screeningResultLabel"];
      }
  }

  static fromJS(data: any): Answer {
      data = typeof data === 'object' ? data : {};
      let result = new Answer();
      result.init(data);
      return result;
  }

  toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data["questionFieldName"] = this.questionFieldName;
      data["answerText"] = this.answerText;
      data["screeningResultLabel"] = this.screeningResultLabel;
      return data;
  }
}
export interface IAnswer {
  questionFieldName: string | undefined;
  answerText: string | undefined;
  screeningResultLabel: string | undefined;
}
